$(document).ready(function() { 
    $("#function-1").hover(function() { 
        $("#carousel-3").carousel(0);
    });
    $("#function-2").hover(function() { 
        $("#carousel-3").carousel(1);
    }); 
    $("#function-3").hover(function() { 
        $("#carousel-3").carousel(2);
    }); 
    $("#function-4").hover(function() { 
        $("#carousel-3").carousel(3);
    }); 
    $("#function-5").hover(function() { 
        $("#carousel-3").carousel(4);
    }); 
    $("#function-6").hover(function() { 
        $("#carousel-3").carousel(5);
    }); 
}); 